import { inView } from 'motion';
import { counter } from '../utils/animations';

class MSScrollTriggeredAnimator {
  dom: { el: any; animatedElements: any[] };
  animation: any;

  constructor(el: any) {
    this.dom = {
      el,
      animatedElements: [el, ...el.querySelectorAll('[data-animate="true"]')]
    };

    this.animation = this.dom.el.dataset.animation;
  }

  init() {
    inView(
      this.dom.el,
      () => {
        this.animate();
      },
      { margin: '0px 0px -20% 0px' }
    );
  }

  animate() {
    this.dom.animatedElements.forEach((element: HTMLElement) => {
      switch (element.dataset.animation) {
      case 'fade':
        element.classList.remove('fade');
        element.classList.add('fade-in');
        break;
      case 'slide-up':
        element.classList.remove('slide-up');
        element.classList.add('slide-in');
        break;
      case 'slide-left':
        element.classList.remove('slide-left');
        element.classList.add('slide-in');
        break;
      case 'slide-right':
        element.classList.remove('slide-right');
        element.classList.add('slide-in');
        break;
      case 'counter':
        counter({ element, play: true });
        break;
      }
    });
  }
}

export default MSScrollTriggeredAnimator;
